import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/account';
// @ts-ignore
import _ from 'lodash';
// @ts-ignore
import SupplierChoose from 'containers/Login/SupplierChoose';

import PropTypes from 'prop-types';
import messages from 'messages';

interface ChangeSupplierModalProps {
  onMenuVisibleChange: Function;
}

class ChangeSupplierModal extends React.Component<
  ChangeSupplierModalProps,
  any
> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: ChangeSupplierModalProps) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  public handleShow = (e?: React.MouseEvent) => {
    const { onMenuVisibleChange } = this.props;
    const { showModal } = this.state;
    e && e.stopPropagation();
    !showModal && onMenuVisibleChange(false);
    this.setState({ showModal: true });
  }

  public render() {
    const { intl } = this.context;
    const { showModal } = this.state;
    return (
      <span onClick={(e) => e.stopPropagation()}>
        <SupplierChoose
          visible={showModal}
          onChangeVisible={(v: boolean) =>
            this.setState({
              showModal: v,
            })
          }
        />
      </span>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<actions.AccountActions>) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangeSupplierModal);
